import HtmlElements from "../../util/HtmlElements.js";
import {safeText} from "../../util/CommonUtils.js";

export default class BarButton extends HTMLElement {
    connectedCallback() {
        const template = document.createElement('template');
        const icon = HtmlElements.iconByName(this.getAttribute('icon'));
        const text = this.getAttribute('text');
        template.innerHTML = this._template(icon, text);
        this.attachShadow({mode: 'open'}).appendChild(template.content.cloneNode(true))
    }


    _template(icon, text){
        return `<style> @import "/ui/js/components/substance-bar/barButton.css?v=2"; </style>
            <div class="bar-button__add-substance-button">${icon}
            <span>${safeText(text)}</span></div>`;
    }
}